import http from "../clients/http";

export interface ReportDeliveryIssueDto {
  orderId: string;
  reason: string;
  description?: string;
}

export interface ReportDeliveryIssueResponse {
  success: boolean;
  message: string;
  sentTo: number;
}

class SupportServiceClass {
  async reportDeliveryIssue(
    data: ReportDeliveryIssueDto,
  ): Promise<ReportDeliveryIssueResponse> {
    const response = await http.post("/support/delivery-issue", data);
    return response.data;
  }

  async getSearchAssistance(query: string, size: number = 5, page: number = 1) {
    const response = await http.get(
      `/support/search-assistance?query=${encodeURIComponent(query)}&size=${size}&page=${page}`,
    );
    return response.data;
  }
}

export const SupportService = new SupportServiceClass();
